import { MbDialog, MbBadge, MbIcon } from '@am/moebius';
import {
  Component,
  OnInit,
  Input,
  ViewContainerRef,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { DetailService } from '@core/services/detail.service';
import { ProviderDialogComponent } from '@commons/provider-dialog/provider-dialog.component';
@Component({
    selector: 'provider-info',
    templateUrl: './provider-info.component.html',
    standalone: true,
    imports: [
        MbBadge,
        MbIcon,
    ],
})
export class ProviderInfoComponent implements OnInit {
  @ViewChild('providerDialog')
  providerDialog: TemplateRef<any>;

  @Input()
  cluster: any;
  @Input()
  isExperts: boolean;
  public finalCost: number;
  public currencyCode: string;
  public polcomId: string;
  public rateInfo: any;

  constructor(
    private vcr: ViewContainerRef,
    private dialog: MbDialog,
    private detailService: DetailService,
  ) {}

  ngOnInit() {
    this.initialize();
  }

  initialize() {
    this.detailService.getRateInfo(this.cluster.rates[0].id).subscribe((res) => {
      this.rateInfo = {
        polcomId: res.polcom_id,
        dynamicPrice: res.dynamic_price,
      };
    });
    this.initializeCostAndCurrency();
  }

  initializeCostAndCurrency() {
    let costValue = this.cluster.rates[0].price.cost.value;
    const CHARGES = this.cluster.rates[0].price.charges;
    CHARGES.forEach((charge) => {
      if (charge.type === 'IMP_LEY_27541') {
        costValue = costValue - charge.amount;
      }
    });
    this.finalCost = costValue;
    this.currencyCode = this.cluster.rates[0].price.currency.code;
  }

  openModalProvider() {
    this.dialog.open(ProviderDialogComponent, {
      closeOnEscKey: true,
      closeOnBackdropClick: true,
      viewContainerRef: this.vcr,
      dialogData: {
        cluster: this.cluster,
        currencyCode: this.currencyCode,
        rateInfo: this.rateInfo,
        finalCost: this.finalCost,
      },
    });
  }
}
